import React from 'react';
import {
  Information, Stack, Text, UnorderedList, useTranslation, Link, Trans,
} from '@piwikpro/ui-components';

export const DeleteUserGroupModal = (
  { showExternalIdpInfo = false },
) => {
  const { t } = useTranslation();

  return (
    <Stack spacing="narrow" vertical>
      {showExternalIdpInfo && (
        <>
          <Stack.Item fill>
            <Information type="warning">
              <Trans
                i18nKey="administration:user-groups.deleteConfirm.externalIdpInfo"
                components={[
                  <Link href="https://help.piwik.pro/support/account/automated-provisioning/" size="small">automated-provisioning</Link>,
                ]}
              />
            </Information>
          </Stack.Item>
          <Stack.Item />
        </>
      )}
      <Stack.Item>
        <Text as="p">{t('administration:user-groups.deleteConfirm.message-line-1')}</Text>
      </Stack.Item>
      <Stack.Item previousSpacing="none">
        <UnorderedList>
          <UnorderedList.Item>
            <Text as="p">{t('administration:user-groups.deleteConfirm.unordered-list.line-1')}</Text>
          </UnorderedList.Item>
          <UnorderedList.Item>
            <Text as="p">{t('administration:user-groups.deleteConfirm.unordered-list.line-2')}</Text>
          </UnorderedList.Item>
        </UnorderedList>
      </Stack.Item>
      <Stack.Item>
        <Text as="p">{t('administration:user-groups.deleteConfirm.message-line-3')}</Text>
      </Stack.Item>
    </Stack>
  );
};
